import SaveExcel from 'exceljs-export'

export const ExportToExcel = (body: any, name: string, headers: any) => {
  SaveExcel({ data: body, documentName: name, titles: headers})
}
